package com.trevorwiebe.timesheet.admin.reporting.presentation

import com.trevorwiebe.timesheet.admin.reporting.domain.LoadWithoutTruck
import com.trevorwiebe.timesheet.admin.reporting.domain.MissingStartEndBoundary
import kotlinx.datetime.LocalDate

sealed class ReportingEvent {
    data class OnFilterByEquipment(val equipmentId: String?) : ReportingEvent()
    data class OnFilterByEmployee(val employeeId: String?) : ReportingEvent()

    data object OnStartDateClick : ReportingEvent()
    data object OnEndDateClick : ReportingEvent()
    data class OnStartDateSelected(val date: LocalDate) : ReportingEvent()
    data class OnEndDateSelected(val date: LocalDate) : ReportingEvent()
    data object OnDismissStartPicker : ReportingEvent()
    data object OnDismissEndPicker : ReportingEvent()

    data class OnSelectReportType(val reportType: ReportType) : ReportingEvent()

    data class OnMissingBoundaryClick(val boundary: MissingStartEndBoundary) : ReportingEvent()
    data class OnFixMileageChanged(val text: String) : ReportingEvent()
    data class OnFixLocationChanged(val text: String) : ReportingEvent()
    data object OnSaveFix : ReportingEvent()
    data object OnConfirmFixWarning : ReportingEvent()
    data object OnDismissFixDialog : ReportingEvent()

    data class OnSetTruckClick(val row: LoadWithoutTruck) : ReportingEvent()
    data class OnTruckSelected(val equipmentId: String) : ReportingEvent()
    data object OnDismissSetTruck : ReportingEvent()
}
